import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import accountService from "./../../../services/accountService";

const AccountReportHeader = ({ id }) => {
  const [account, setAccount] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      const result = await accountService.getAccountInfoAsync(id);
      if (!result) window.location = "/404";
      if (mounted) setAccount(result);
    };

    fetchAccount(id);

    return () => {
      mounted = false;
    };
  }, [id, setAccount]);

  const renderName = () => {
    if (account) {
      const { first_name, middle_name, last_name } = account;
      return `Dr. ${first_name} ${middle_name} ${last_name}`;
    }
  };

  return (
    <div className="block lg:flex justify-between items-center">
      <div>
        <p className="text-gray-500">Manage Reports</p>
        <Link
          className="text-gray-400 text-sm hover:text-blue-500"
          to={`/accounts/${id}`}
        >
          {renderName()}
        </Link>
      </div>
    </div>
  );
};

export default AccountReportHeader;
